import { render, staticRenderFns } from "./drawer-user-group-search-result.vue?vue&type=template&id=6841f3da&"
import script from "./drawer-user-group-search-result.vue?vue&type=script&lang=js&"
export * from "./drawer-user-group-search-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports